import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DocumentosProjeto } from '../../models/documentos-projeto.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { DocumentosProjetoService } from '../../services/documentos-projeto.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-documento-edit',
  templateUrl: './detalhe-documento-edit.component.html',
  styleUrls: ['./detalhe-documento-edit.component.scss']
})
export class DetalheDocumentoEditComponent extends BaseFormComponent<DocumentosProjeto> implements OnInit {

  actionLabel: string = 'Novo';
  selectedFile: File | null = null;
  queryParams : any;
  redirHelper: any;
  permissions: ProjetoPermission;
  @Input() idPgIndicador: number;
  @Input() idDoc: number;
  @Input() _entity: DocumentosProjeto;

  constructor(
    private myService: DocumentosProjetoService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

	async ngOnInit(): Promise<void> {
		try {
			this.queryParams = {};
			if (this.activatedRoute.snapshot.queryParams['prt_issue_id']) {
				this.queryParams.prt_issue_id = this.activatedRoute.snapshot.queryParams['prt_issue_id'];
			} else if (this.activatedRoute.snapshot.queryParams['ind_id']) {
				this.queryParams.ind_id = this.activatedRoute.snapshot.queryParams['ind_id'];
			} else if (this.activatedRoute.snapshot.queryParams['pf_id']) {
				this.queryParams.pf_id = this.activatedRoute.snapshot.queryParams['pf_id'];
			} else if (this.idPgIndicador) {
				this.queryParams.pg_ind_id = this.idPgIndicador;
			} else if (this.idDoc) {
				this.queryParams.doc_id = this.idDoc;
			} else {
				throw new Error('Nao encontrei parametro');
			}
			this.redirHelper = await this.myService.resolveAccordAndRedir(this.queryParams);
			this.initForm();
			this.loaded();
		} catch (e) {
			console.log(e.message);
		}
	}

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      file: new FormControl(null, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.form.get("file").clearValidators();
      this.form.get("file").updateValueAndValidity();
    }
  }

	voltar() {
		this.navigation.back([this.redirHelper.redirTo]);
	}

	getDataCreate() {
		let formData: FormData = new FormData();
    formData.append('description', this.form.value.description);
    formData.append('title', this.form.value.title);
    if(this.selectedFile){
      formData.append('file', this.selectedFile, this.selectedFile?.name);
    }
		if (this.queryParams.prt_issue_id) {
			formData.append('prt_issue_id', this.queryParams.prt_issue_id);
		} else if (this.queryParams.ind_id) {
			formData.append('ind_id', this.queryParams.ind_id);
		} else if (this.queryParams.pg_ind_id) {
			formData.append('pg_ind_id', this.queryParams.pg_ind_id);
		} else if (this.queryParams.pf_id) {
			formData.append('pf_id', this.queryParams.pf_id);
		} else if (this.queryParams.doc_id) {
			formData.append('doc_id', this.queryParams.doc_id);
		}
		return formData;
	}

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.updateDocumento(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.entity = res;
              this.loaded();
              this.confirmation("Documento alterado com sucesso!").subscribe(() => {
                window.location.reload();
              })
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.createDocumento(this.getDataCreate()).subscribe({
            next: (res) => {
              // this.increaseDocumentosItens();
              this.confirmation('Documento criado com sucesso!').subscribe(() => {
                if (this.queryParams.pg_ind_id) {
                  this.navigation.replace(['/projetos', 'documentos', res.id], { queryParams: this.queryParams });
                } else if (this.queryParams.doc_id) {
                  this.navigation.replace(['/projetos/tutoriais', res.id], { queryParams: this.queryParams });
                } else {
                  this.navigation.replace(['projetos', 'projeto', this.redirHelper.pf_id, 'documentos', res.id], { queryParams: this.queryParams });	
                }
              });
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  // increaseDocumentosItens() {
  //   this.infoProjeto.menu['documentos'].itens++;
  //   this.pesquisaGeralService.setInfoProject(this.infoProjeto);
  // }

  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

  download() {
    this.loading();
    this.addSub(
      this.myService.download(this.entity?.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get('content-disposition');
          const fileName = contentDispositionHeader ? this.myService.extractFilename(contentDispositionHeader) : this.entity?.name;
          const blob = new Blob([res.body], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = "Arquivo não encontrado.";
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }
}
